import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberCancelReasonForm from '../../../components/forms/MemberCancelReasonForm';
import { useCreateMemberCancelReason } from '../../../hooks/useMemberCancelReasonApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberCancelReasonDTO } from '../../../services/apiClient';

const MemberCancelReasonCreate: React.FC = () => {
  const navigate = useNavigate();
  const createMutation = useCreateMemberCancelReason();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Cancel Reasons', href: '/admin/membercancelreasons' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberCancelReasonDTO) => {
    try {
      setIsSubmitting(true);
      await createMutation.mutateAsync(data);
      navigate('/admin/membercancelreasons');
    } catch (error) {
      console.error('Error creating MemberCancelReason:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/membercancelreasons"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberCancelReason.Edit'
    >
        <MemberCancelReasonForm
          initialValues={{} as MemberCancelReasonDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/membercancelreasons')}
        />
    </AdminLayout>
  );
};

export default MemberCancelReasonCreate;